<template>
  <div class="justify_container">
    <div class="header center_item">
      <span>
        <img class="igames_icon" :src="require(`@/assets/images/icon_48.png`)"/>
        <span class="panel_name">{{panelName}}</span>
      </span>
    </div>
    <div class="panel_container">
      <div class="left_part parts">
        <CustomButton :name="'ADICIONAR NOVO'" :active="gameSettings.saveButtonActive" @ontap="addNewGame()" />
        <CustomInput :label="'Procurar'" :background="'var(--background0)'" @event="searchGame" :margin="'20px'"/>
        <div class="game_list custom_scroll">
          <div class="game_item" v-for="game in games" v-bind:key="game.id" @click="selectGame(game.id)">
            <div class="game_item_name"> {{getGameTitle(game)}}</div>
            <div class="game_item_info_col">
              <div><b-icon-eye class="eye_icon"/> {{game.views}}</div>
              <div class="game_id_label" @click.stop="copyGameId(game.id)">ID: {{game.id}}</div>
            </div>
            <div class="game_item_info_col">
              <div>{{game.date.split(" ")[0].replaceAll("-","/")}}</div>
              <div>{{game.update_date ? game.update_date.split(" ")[0].replaceAll("-","/") : ''}}</div>
            </div>
            <div class="center_item"><div class="post_status" :class="{'post_status_published':game.published}"></div></div>
          </div>
          <div class="center_horizontal"><Loading :color="'#7d7d7d'" :size="'40px'" v-if="loadingGames" /></div>
          <CustomButton :name="'CARREGAR MAIS'" @click="getGames()" class="load_more" v-if="!loadingGames && nextPage <= pages && nextPage > 0 && !searchingGames"/>
        </div>
        <CustomButton :name="'CONFIGURAÇÕES'" @click="openConfigs()" />
        <CustomButton :name="'TEMPORADAS'" @click="seasonManagerVisible = true" />
      </div>

      <div class="middle_part parts">
        <div class="game_superior_part">
          <label for="upload_image" v-cloak @drop.prevent="uploadLogo" @dragover.prevent>
            <div class="game_logo" :style="{'background-image': `url('${getImage(getGameEdit().logo)}')`}">
              <div class="card_game_add_action delete_print_action" v-if="getGameEdit().logo != ''">
                <b-icon-arrow-repeat class="trash_icon" />
              </div>
              <div class="icon_with_label" v-if="getGameEdit().logo == '' && !gameSettings.uploadingLogo">
                <p>CAPA</p>
                <b-icon-plus-circle-dotted class="logo_icon" />
              </div>
              <Loading :color="'#7d7d7d'" :size="'40px'" v-if="gameSettings.uploadingLogo"/>
            </div>
          </label>
          <input type="file" accept="image/*" id="upload_image" ref="logoFile" hidden @change="uploadLogo()"/>
          <div class="align_self">
            <CustomInput v-model="gameEdit.langs[gameSettings.currentLanguage].title" :label="'Título'" :background="'var(--background0)'" :margin="'10px'"/>
            <CustomTextArea v-model="gameEdit.langs[gameSettings.currentLanguage].description" :label="'Descrição'" :background="'var(--background0)'" :height="'232px'"/>
          </div>
        </div>

        <div class="game_details_input">
          <CustomInput :label="'Ano'" v-model="gameEdit.langs[gameSettings.currentLanguage].year" :background="'var(--background0)'" :margin="'16.5px'" :small="true"/>
          <CustomInput :label="'Tamanho'" v-model="gameEdit.langs[gameSettings.currentLanguage].size" :background="'var(--background0)'" :margin="'16.5px'" :small="true"/>
          <CustomInput :label="'Idiomas'" v-model="gameEdit.langs[gameSettings.currentLanguage].game_lang" :background="'var(--background0)'" :margin="'16.5px'" :small="true"/>
          <!--
          <div class="game_lang_input_div">
            <CustomInput
              :label="'Linguagem - code'"
              v-model="gameEdit.langs[gameSettings.currentLanguage].game_lang"
              @focus="gameLangSuggestionVisible = true"
              @blur="gameLangSuggestionVisible = false"
              :background="'var(--background0)'"
              :margin="'16.5px'"
              :small="true"
            />
            <div class="game_lang_suggestion" v-if="gameLangSuggestionVisible">
              <div class="item_popup" @click="gameEdit.langs[gameSettings.currentLanguage].game_lang='pt'">
                português
              </div>
              <div class="item_popup" @click="gameEdit.langs[gameSettings.currentLanguage].game_lang='en'">
                inglês
              </div>
              <div class="item_popup" @click="gameEdit.langs[gameSettings.currentLanguage].game_lang='es'">
                espanhol
              </div>
            </div>
          </div>
          -->
        </div>

        <div class="grid_columns_2">
          <CustomInput v-model="gameEdit.langs[gameSettings.currentLanguage].download_url" :label="'Link de Download'" :margin="'16.5px'" :background="'var(--background0)'" :height="'232px'"/>
          <CustomInput v-model="gameEdit.langs[gameSettings.currentLanguage].download_url_premium" :label="'Link de Download Premium'" :margin="'16.5px'" :background="'var(--background0)'" :height="'232px'"/>
        </div>
        <div class="grid_columns_2">
          <Selector :items="gameArcSupported" :selected="arcSelected" @change="changeGameArc"/>
          <Selector :items="gameTypeOptions" :selected="typeSelected" @change="changeGameType" :suffix="''"/>
        </div>
        <div class="grid_columns_2">
          <CustomInput v-model="gameEdit.langs[gameSettings.currentLanguage].video" :label="'Link de video'" :margin="'16.5px'" :background="'var(--background0)'" :height="'232px'"/>
          <CustomInput v-model.number="gameEdit.avaliable_after_code" :label="'Disponível após código de versão'" :margin="'16.5px'" :background="'var(--background0)'" type="number"/>
        </div>
        <div class="game_prints horizontal_scroll">
          <div
          class="prints_image"
          v-for="(item, index) in gameEdit.langs[gameSettings.currentLanguage].prints"
          v-bind:key="'print_'+index"
          :style="{'background-image': `url('${getImage(getGameEdit().prints[index])}')`}">
            <div class="card_game_add_action delete_print_action">
              <b-icon-trash class="trash_icon" @click="deleteGamePrint(index)"/>
            </div>
            <Loading :color="'#7d7d7d'" :size="'40px'" v-if="gameSettings.uploadingPrints"/>
          </div>
          <label for="upload_prints" v-cloak @drop.prevent="uploadPrints" @dragover.prevent>
            <div class="icon_with_label add_prints">
              <p>PRINTS</p>
              <b-icon-plus-circle-dotted class="logo_icon" />
            </div>
          </label>
        </div>

        <input type="file" accept="image/*" multiple id="upload_prints" ref="printFiles" hidden @change="uploadPrints()"/>
      </div>

      <div class="right_part parts" >
        <CustomButton :name="gameEdit.id == 0 ? 'SALVAR' : 'ATUALIZAR'" :active="gameSettings.saveButtonActive" @ontap="saveGame()"/>

        <div class="config_item">
          <div class="card_item_name">PUBLICADO</div>
          <div class="center_item card_item_action"><CheckBox value="foo" :checked="gameEdit.published" @chg="changePublished"/></div>
        </div>

        <div class="config_item">
          <div class="card_item_name">NOTIFICAR</div>
          <div class="center_item card_item_action"><CheckBox value="foo" :checked="gameEdit.notify" @chg="changeNotify"/></div>
        </div>

        <div class="cards_game">
          <div class="card_game_header">
            <div class="card_game_name">
              Idiomas
            </div>
          </div>
          <div class="card_content card_content_langs">
            <div class="card_item pointer" :class="{item_selected:isThisLanguage(gameSettings.languages.pt)}" @click="changeGameLanguage(gameSettings.languages.pt)">
              <div class="card_item_name"><img class="flag_item" :src="require(`@/assets/images/brazil_flag.png`)"/> PORTUGUÊS</div>
              <div class="center_item"><div class="post_status" :class="{'post_status_published':langIsOk(gameSettings.languages.pt)}"></div></div>
            </div>
            <div class="card_item pointer" :class="{item_selected:isThisLanguage(gameSettings.languages.en)}" @click="changeGameLanguage(gameSettings.languages.en)">
              <div class="card_item_name"><img class="flag_item" :src="require(`@/assets/images/usa_flag.png`)"/> INGLÊS</div>
              <div class="center_item"><div class="post_status" :class="{'post_status_published':langIsOk(gameSettings.languages.en)}"></div></div>
            </div>
            <div class="card_item pointer" :class="{item_selected:isThisLanguage(gameSettings.languages.es)}" @click="changeGameLanguage(gameSettings.languages.es)">
              <div class="card_item_name"><img class="flag_item" :src="require(`@/assets/images/spain_flag.png`)"/> ESPANHOL</div>
              <div class="center_item"><div class="post_status" :class="{'post_status_published':langIsOk(gameSettings.languages.es)}"></div></div>
            </div>
          </div>
        </div>

        <div class="cards_game">
          <div class="card_game_header">
            <div class="card_game_name">
              Categorias
            </div>
            <div class="card_game_action" @click="gameSettings.addCategoryVisible = gameSettings.addCategoryVisible ? false: true">
              <b-icon-plus-lg class="card_action_icon"/>
            </div>
          </div>
          <div class="card_add_item" v-if="gameSettings.addCategoryVisible" >
            <div style="width:calc(100% - 10px);">
              <CustomInput :label="'Nome'" v-model="gameSettings.newCategory" :background="'var(--background1)'" :margin="'15px'" :small="true"/>
            </div>
            <div class="card_game_add_action" @click="addCategory()">
              <b-icon-check class="check_icon"/>
            </div>
          </div>
          <div class="card_content custom_scroll" :class="{height_205:!gameSettings.addCategoryVisible}">
            <div class="card_item tree" v-for="item in gameSettings.categories" v-bind:key="item.id">
              <div class="edit_item_action" @click="editCategory(item)"><b-icon-pen/></div>
              <div class="card_item_name">{{item.name}}</div>
              <div class="center_item card_item_action"><CheckBox :value="item.id" :checked="item.checked" @chg="selectCategory"/></div>
            </div>
          </div>
        </div>
        <CustomButton :name="'EXCLUIR'" v-if="gameEdit.id > 0" class="red_color" :active="gameSettings.saveButtonActive" @ontap="openDeleteGameDialog(safeCopyObject(gameEdit))"/>
      </div>

      <div class="extra_right_part parts">
        <CustomButton :name="'ADD SAVE DE UM GAME'" :active="savesSettings.saveButtonActive" @ontap="addNewSave()" style="display:none;"/>
        <div class="saves_list custom_scroll">
          <div class="save_card" v-for="(save, index) in gameSaves" v-bind:key="'save_'+index">
            <div class="save_card_header">
              <span class="save_card_title">{{save.game_name || 'Novo Game'}}</span>
              <b-icon-trash class="trash_icon save_delete_icon" @click="deleteSave(save, index)"/>
            </div>
            <div class="save_card_row">
              <CustomInput :label="'ID do Jogo'" v-model="save.game_id" :background="'var(--background1)'" :margin="'8px'" :small="true"/>
              <CustomInput :label="'Serial'" v-model="save.serial" :background="'var(--background1)'" :margin="'8px'" :small="true"/>
            </div>
            <div class="save_link_item" v-for="(link, li) in save.links" v-bind:key="'link_'+index+'_'+li">
              <span class="save_link_label">Save #{{li + 1}}</span>
              <CustomInput :label="'Link do Save'" v-model="save.links[li].url" :background="'#232323'" :margin="'8px'" :small="true"/>
              <div class="save_card_downloads">
                <b-icon-download class="download_icon"/> {{link.downloads || 0}}
              </div>
              <b-icon-trash class="trash_icon save_link_delete" @click="deleteSaveLink(save, li)"/>
              <CustomTextArea v-model="save.links[li].description" :label="'Descrição'" :background="'#232323'" :height="'43px'" :margin="'9px'" class="save_link_description"/>
            </div>
            <div class="save_card_actions">
              <CustomButton :name="'ADD SAVE'" @ontap="addSaveLink(index)" class="save_card_btn save_add_link_btn"/>
              <CustomButton :name="'SALVAR'" @ontap="saveSave(save, index)" class="save_card_btn" :active="savesSettings.saveButtonActive"/>
            </div>
          </div>
        </div>

        <div class="notif_section">
          <div class="notif_click_card notif_token_card">
            <div class="notif_click_label">NOTIFICÁVEIS</div>
            <div class="notif_click_value">{{notificationsData.totalTokens}}</div>
          </div>
          <div class="notif_clicks_row">
            <div class="notif_click_card">
              <div class="notif_click_label">CLICKS HOJE</div>
              <div class="notif_click_value">{{notificationsData.clicksToday}}</div>
            </div>
            <div class="notif_click_card">
              <div class="notif_click_label">CLICKS ONTEM</div>
              <div class="notif_click_value">{{notificationsData.clicksYesterday}}</div>
            </div>
          </div>
          <div class="notif_list custom_scroll">
            <div class="notif_item" v-for="notif in notificationsData.notifications" v-bind:key="'notif_'+notif.id">
              <div class="notif_item_top">
                <div class="notif_item_img" :style="{'background-image': `url('${notif.image_url}')`}"></div>
                <div class="notif_item_info">
                  <div class="notif_item_title">{{notif.title}}</div>
                  <div class="notif_item_status" :class="{'notif_status_done': notif.status === 'completed'}">{{notif.status}}</div>
                </div>
              </div>
              <div class="notif_progress_bar" v-if="notif.total_batches > 0">
                <div class="notif_progress_fill" :style="{ width: getNotifProgress(notif) + '%' }"></div>
                <span class="notif_progress_text">{{getNotifProgress(notif)}}%</span>
              </div>
              <div class="notif_item_cards">
                <div class="notif_stat_card">
                  <div class="notif_stat_label">ENVIADOS</div>
                  <div class="notif_stat_value notif_stat_sent">{{notif.sent_count}}</div>
                </div>
                <div class="notif_stat_card">
                  <div class="notif_stat_label">FALHOU</div>
                  <div class="notif_stat_value notif_stat_failed">{{notif.failed_count}}</div>
                </div>
                <div class="notif_stat_card">
                  <div class="notif_stat_label">CLICKS</div>
                  <div class="notif_stat_value notif_stat_clicks">{{notif.clicks}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="parts bottom_part">
      <div class="cards_game users_online_card" id="app_uses_chart">
          <UsersStatistics/>
      </div>

      <OnlinePlayingStatus/>

      <SearchesInApp/>

      <GamesReviews/>
      </div>
    </div>

    <div class="playing_games_section">
      <div class="playing_games_list horizontal_scroll">
        <div class="gallery_card" v-for="game in playingGames" v-bind:key="'gallery_'+game.game_id" @click="selectGame(game.game_id)">
          <div
            class="gallery_item"
            :style="{'background-image': `url('${getImage(game.logo)}')`}"
          ></div>
          <div class="gallery_card_info"><b-icon-controller/> {{game.playing}}</div>
        </div>
      </div>
    </div>

    <FloatSettings :title="'JOGOS EM DESTAQUE'" :visible="highlightsGamesVisible" @onclose="highlightsGamesVisible = false">
     <HighlightsGames/>
    </FloatSettings>

    <FloatSettings :title="'CONFIGURAÇÕES'" :visible="configsVisible" @onclose="configsVisible = false">
      <div class="settings">
        <CustomButton :name="'CONFIGURAR JOGOS EM DESTAQUE'" @click="highlightsGamesVisible = true; configsVisible = false" />
      </div>
    </FloatSettings>

    <FloatSettings :title="'EDITAR CATEGORIA'" :visible="editCategoryVisible" @onclose="editCategoryVisible = false">
      <div class="edit_category">
        <CustomInput :label="'Nome'" v-model="categoryEdit.name" :background="'var(--configsBC)'" :margin="'15px'"/>
        <CustomButton :name="'SALVAR'" @click="updateCategory()" />
        <CustomButton :name="'EXCLUIR'" @click="deleteCategory()" class="red_color"/>
      </div>
    </FloatSettings>

    <FloatSettings :title="'EXCLUIR GAME'" :visible="deleteGame.visible" @onclose="deleteGame.visible = false">
      <div class="edit_category">
        <span class="span_text">tem certeza que seseja excluir esse game?</span>
        <CustomButton :name="'SIM'" @click="deleteGameConfirmed()" />
        <CustomButton :name="'NÃO'" @click="deleteGame.visible = false" />
      </div>
    </FloatSettings>

    <div class="repack_reopen" v-if="!repackDialog.visible" @click="openRepackDialog()" title="Abrir REPACK">
      <b-icon-box-seam/> REPACK
    </div>

    <FloatSettings :title="'REPACK'" :visible="repackDialog.visible" @onclose="repackDialog.visible = false">
      <div class="repack_dialog">
        <div class="repack_switches">
          <div class="repack_switch_row">
            <span class="repack_switch_label">Repack</span>
            <label class="repack_toggle">
              <input type="checkbox" v-model="repackDialog.repack" @change="updateRepack()" :disabled="repackDialog.saving"/>
              <span class="repack_slider"></span>
            </label>
          </div>
          <div class="repack_switch_row">
            <span class="repack_switch_label">Old Links</span>
            <label class="repack_toggle">
              <input type="checkbox" v-model="repackDialog.oldLinks" @change="updateRepack()" :disabled="repackDialog.saving"/>
              <span class="repack_slider"></span>
            </label>
          </div>
        </div>
        <div class="repack_logs_header">
          <span class="repack_logs_title">LOGS</span>
          <b-icon-arrow-repeat class="repack_logs_refresh" @click="getRepackLogs()"/>
        </div>
        <div class="repack_logs custom_scroll" ref="repackLogs">{{ repackDialog.logs || 'Sem logs.' }}</div>
      </div>
    </FloatSettings>

    <SeasonManager :visible="seasonManagerVisible" @onclose="seasonManagerVisible = false" />

  </div>
</template>

<script src="@/controllers/panelController.js"></script>

<style  src="@/styles/panel.css">

</style>

<style scoped>
  .repack_reopen {
    position: fixed;
    top: 14px;
    right: 16px;
    z-index: 90;
    display: flex;
    align-items: center;
    gap: 6px;
    background: var(--theme);
    color: #1c1c1c;
    padding: 8px 14px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
  }
  .repack_dialog {
    width: min(600px, 88vw);
    color: var(--textColor);
  }
  .repack_switches {
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 8px 4px 16px;
  }
  .repack_switch_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .repack_switch_label {
    font-size: 16px;
    font-weight: bold;
  }
  .repack_toggle {
    position: relative;
    display: inline-block;
    width: 52px;
    height: 28px;
  }
  .repack_toggle input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .repack_slider {
    position: absolute;
    cursor: pointer;
    inset: 0;
    background: #101010;
    border-radius: 28px;
    transition: 0.2s;
  }
  .repack_slider:before {
    content: "";
    position: absolute;
    height: 22px;
    width: 22px;
    left: 3px;
    top: 3px;
    background: #797979;
    border-radius: 50%;
    transition: 0.2s;
  }
  .repack_toggle input:checked + .repack_slider {
    background: var(--theme);
  }
  .repack_toggle input:checked + .repack_slider:before {
    transform: translateX(24px);
    background: #fff;
  }
  .repack_toggle input:disabled + .repack_slider {
    opacity: 0.5;
    cursor: default;
  }
  .repack_logs_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 4px 4px 6px;
  }
  .repack_logs_title {
    font-size: 13px;
    color: #9a9a9a;
    letter-spacing: 1px;
  }
  .repack_logs_refresh {
    color: #9a9a9a;
    cursor: pointer;
  }
  .repack_logs {
    height: 320px;
    overflow-y: auto;
    background: #101010;
    border-radius: 8px;
    padding: 12px;
    font-size: 11px;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
    color: #cfcfcf;
    font-family: monospace;
  }
</style>